import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseSectionEditComponent } from '../base-section-edit/base-section-edit.component';
import { AlertService } from 'src/app/services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SectionService } from 'src/app/services/section.service';
import { fuseAnimations } from '@mobileia/layout-fuse';

@Component({
  selector: 'app-section-edit-two',
  templateUrl: './section-edit-two.component.html',
  styleUrls: ['./section-edit-two.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class SectionEditTwoComponent extends BaseSectionEditComponent implements OnInit {

  constructor(
    protected alertService: AlertService,
    protected route: ActivatedRoute,
    protected navigator: Router,
    protected service: SectionService
  ) {
    super(alertService, route, navigator, service);
  }

}
